module.exports = __webpack_public_path__ + "static/media/loandepot.7c6ef2e8.png";